import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSliderModule } from "@angular/material/slider";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DigitOnlyModule } from "@uiowa/digit-only";
import { ChartsModule } from "ng2-charts";
import { NgxsModule } from "@ngxs/store";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { SharedModuleModule } from "@/shared-module/shared-module.module";
import {
  JwtInterceptor,
  ErrorInterceptor,
  CourseLockedInterceptor,
} from "@/shared-module/helpers";
import {
  LoginComponent,
  DashboardComponent,
  CompanyComponent,
  MarketComponent,
  PageNotFoundComponent,
  PageErrorComponent,
  CourseLockedComponent,
  ConnectComponent,
  LogoutComponent,
  DocumentsComponent,
  TeamComponent,
} from "@/core/pages";
import {
  AlertComponent,
  DemoDialogComponent,
  DocumentsTableComponent,
  MemberListComponent,
  MemberNamesListComponent,
  MemberEditComponent,
  MemberRemoveComponent,
  PasswordLostComponent,
} from "@/core/components";

import { SafePipe, AuthImagePipe } from "@/core/pipes";

@NgModule({
  declarations: [
    AlertComponent,
    AppComponent,
    AuthImagePipe,
    CompanyComponent,
    ConnectComponent,
    CourseLockedComponent,
    DashboardComponent,
    DemoDialogComponent,
    DocumentsComponent,
    DocumentsTableComponent,
    LoginComponent,
    LogoutComponent,
    MarketComponent,
    MemberEditComponent,
    MemberListComponent,
    MemberNamesListComponent,
    MemberRemoveComponent,
    PageNotFoundComponent,
    PageErrorComponent,
    PasswordLostComponent,
    SafePipe,
    TeamComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatSliderModule,
    NgbModule,
    DigitOnlyModule,
    ChartsModule,
    SharedModuleModule,
    NgxsModule.forRoot()
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CourseLockedInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
